module.exports = __webpack_public_path__ + "media/images/patient-icons/treatment-icon-bd177a306c9ae8ba5630e91a98dc3591.svg";